import { Grid, Icon, IconButton, Typography } from '@mui/material'

export const FormUploadFilesPrintEditor = () => {
  return (
    (<Grid
      container
      direction='row'
      alignItems='center'
      style={{ paddingLeft: 5 }}
    >
      <IconButton variant='link' size="large">
        <Icon>download</Icon>
      </IconButton>
      <Typography style={{ marginLeft: 5 }}>
        <b>File name</b>
        <div>File description</div>
      </Typography>
    </Grid>)
  );
}
